import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { NotificationType } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { NotificationPriority } from "../../../../api/graphql";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type UserNotificationViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  typeOptions: { id: string; displayId: string }[];
  type: NotificationType;
  priorityOptions: { id: string; displayId: string }[];
  priority: NotificationPriority | "";
  titleValue?: { displayId: string; id: string } | null;
  title: string;
  bodyValue?: { displayId: string; id: string } | null;
  body: string;
  actorUserValue: { displayId: string; id: string } | null;
  objectTypeValue?: { displayId: string; id: string } | null;
  objectType: string;
  objectIdValue?: { displayId: string; id: string } | null;
  objectId: string;
  actionUrlValue?: { displayId: string; id: string } | null;
  actionUrl: string;
  readAtValue?: { displayId: string; id: string } | null;
  readAt: Date | null;
  notificationCreatedAtValue?: { displayId: string; id: string } | null;
  notificationCreatedAt: Date | null;
  archivedAtValue?: { displayId: string; id: string } | null;
  archivedAt: Date | null;
  metadataValue?: { displayId: string; id: string } | null;
  metadata: string;
};

export const UserNotificationViewForm: React.FC<UserNotificationViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      typeOptions = [],
      type = "" as NotificationType,
      priorityOptions = [],
      priority = "" as NotificationPriority | "",
      title = "",
      body = "",
      actorUserValue,
      objectType = "",
      objectId = "",
      actionUrl = "",
      readAt = null,
      notificationCreatedAt = null,
      archivedAt = null,
      metadata = "{}",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupUserNotificationLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    type
                      ? typeOptions.find((o: { id: string }) => o.id === type)
                          ?.displayId || type
                      : ""
                  }
                  label={langStore.UserNotificationTypeLabel}
                />
                <ShowString
                  value={
                    priority
                      ? priorityOptions.find(
                          (o: { id: string }) => o.id === priority
                        )?.displayId || priority
                      : ""
                  }
                  label={langStore.UserNotificationPriorityLabel}
                />
                <ShowMultiLine
                  value={title}
                  label={langStore.UserNotificationTitleLabel}
                />
                <ShowMultiLine
                  value={body}
                  label={langStore.UserNotificationBodyLabel}
                />
                <ShowReference
                  label={langStore.UserNotificationActorUserLabel}
                  selectedValue={langStore.displayIdByLang(
                    actorUserValue?.displayId
                  )}
                />
                <ShowMultiLine
                  value={objectType}
                  label={langStore.UserNotificationObjectTypeLabel}
                />
                <ShowMultiLine
                  value={objectId}
                  label={langStore.UserNotificationObjectIdLabel}
                />
                <ShowMultiLine
                  value={actionUrl}
                  label={langStore.UserNotificationActionUrlLabel}
                />
                <ShowDateTime
                  value={readAt}
                  label={langStore.UserNotificationReadAtLabel}
                />
                <ShowDateTime
                  value={notificationCreatedAt}
                  label={langStore.UserNotificationNotificationCreatedAtLabel}
                />
                <ShowDateTime
                  value={archivedAt}
                  label={langStore.UserNotificationArchivedAtLabel}
                />
                <InputCodeEditor
                  value={metadata}
                  onChange={() => {}}
                  label={langStore.UserNotificationMetadataLabel}
                  language="json"
                  readOnly={true}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
